import { StationEvent } from "~/api/models/station-event.model";
import { AvoltaAlarmMapping } from "~/configs/alarms/avolta-alarm.config";
import { AvoltaAlarmEnum } from "~/configs/alarms/avolta-alarm.model";

export function isOfflineEvent(event: StationEvent) {
    return event?.message?.includes('offline') || Object.keys(event?.data).includes('oldValue');
}

export function getAlarm(event: StationEvent): AvoltaAlarmEnum | null {
    
    if(isOfflineEvent(event)) {
        return AvoltaAlarmEnum.offline;
    }

    const alarm : AvoltaAlarmEnum =  AvoltaAlarmMapping[event?.data?.type];

    return alarm || null;
}